@if(isLoading | async) {
<div class="overlay">
  <div class="card">
    @switch (size) {
    @case ('small') {
    <main style="width: 20px; height: 20px"></main>
    }
    @case ('middle') {
    <main style="width: 40px; height: 40px"></main>
    }
    @case ('large') {
    <main style="width: 60px; height: 60px"></main>
    }
    }
    <h4>Carregando...</h4>
  </div>
</div>
}
